// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es7.weak-map.of.js
// module id = ./node_modules/core-js/modules/es7.weak-map.of.js
// module chunks = 0